import { render, staticRenderFns } from "./TabVendorClass.vue?vue&type=template&id=11668a53&"
import script from "./TabVendorClass.vue?vue&type=script&lang=js&"
export * from "./TabVendorClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports